import type { IFetchService } from "app/services/fetchService";
import type { DigestSubscription, UpdateDigestSubscriptionDTO } from "../../models/DigestSubscription";

export default function createSignalsAlertsAPIService(fetchService: Readonly<IFetchService>) {
    return {
        updateDigestSubscription(dto: Readonly<UpdateDigestSubscriptionDTO>): Promise<DigestSubscription> {
            return fetchService.put("/sales-api/lead-scoring/digest/subscription", dto);
        },
    };
}
